<template>
  <div>
    <div v-if="bulkActions.length || hasTopRightTools" class="table-tools">
      <m4-level>
        <m4-level-left>
          <m4-select-action
            v-if="bulkActions.length"
            :actions="bulkActions"
            :checked-rows="checkedRows"
          ></m4-select-action>
        </m4-level-left>
        <m4-level-right v-if="hasTopRightTools">
          <slot name="top_right"></slot>
        </m4-level-right>
      </m4-level>
    </div>
    <div :class="'table-responsive' + (dragDropReorder ? ' table-responsive--draggable-tr' : '')">
      <table :class="tableClasses">
        <thead>
          <tr>
            <th v-if="bulkActions.length" class="table__head" width="3%">
              <input type="checkbox" name="checked-all" @click="selectAll" v-model="checkedAll" />
            </th>
            <th v-if="!noActions" class="table__head">
              <slot name="settings"></slot>
            </th>
            <th class="table__head" v-for="(th, index) in thead" :key="index" :data-name="th.name">
              <m4-button v-if="th.sortUrl" tag="a" variant="default-text" :href="th.sortUrl">
                {{ th.title }}
                <m4-icon icon="sort" :class="thSortClasses(th)"></m4-icon>
              </m4-button>
              <m4-button v-else-if="th.jsSort" @click="jsSortBy(th)" tag="a" variant="default-text">
                {{ th.title }}
                <m4-icon icon="sort" :class="thSortClasses(th)"></m4-icon>
              </m4-button>
              <span v-else>{{ th.title }}</span>
            </th>
            <th v-if="hasCustomButtons" class="table__head"></th>
          </tr>
        </thead>
        <tbody v-if="newTBody && newTBody.length">
          <template v-for="(tr, index) in newTBody" :key="index">
            <tr :data-id="tr.id" :class="trClasses(tr, index)" v-bind="trAttr(tr, index)" v-on="trListeners(tr, index)">
              <td v-if="bulkActions.length" class="table__body-cell">
                <m4-form-field
                  type="checkbox"
                  name="checked-rows[]"
                  v-model="checkedRows"
                  @change="select"
                  :native-value="tr.id"
                  :true-value="tr.id"
                  autocomplete="off"
                ></m4-form-field>
              </td>
              <td v-if="!noActions" class="table__body-cell table__body-cell--actions">
                <m4-button v-if="tr.viewUrl" :href="tr.viewUrl" tag="a" variant="default-text">
                  <m4-icon icon="file-alt"></m4-icon>
                </m4-button>
                <m4-button v-if="tr.editUrl" :href="tr.editUrl" tag="a" variant="default-text">
                  <m4-icon icon="edit-alt"></m4-icon>
                </m4-button>
                <template v-if="tr.deleteUrl">
                  <m4-dialog :submit-url="tr.deleteUrl" btn-title="Remove" btn-variant="danger">
                    <template v-slot:button>
                      <m4-button tag="a" variant="default-text" class="btn-delete">
                        <m4-icon icon="trash"></m4-icon>
                      </m4-button>
                    </template>
                    Are you sure you want to delete this record?
                  </m4-dialog>
                </template>
              </td>
              <td v-for="(td, j) in tr.cells" :key="j" :class="tdClasses(tr, td, j)" :data-name="td.name">
                <span v-html="td.value"></span>
                <m4-button
                  v-if="
                    tr.children &&
                    tr.children.length > 0 &&
                    tr.cells.length == j + 1 &&
                    !hasCustomButtons &&
                    (!tr.customButtons || tr.customButtons.length === 0)
                  "
                  tag="a"
                  size="sm"
                  class="btn__expand"
                  circle
                  @click="openDetail(tr.id)"
                >
                  <m4-icon icon="angle-down" class="btn__icon"></m4-icon>
                </m4-button>
              </td>
              <td
                v-if="tr.customButtons && tr.customButtons.length > 0"
                class="table__body-cell table__body-cell--custom-buttons table__body-cell--pr"
              >
                <m4-button
                  v-for="customButton in tr.customButtons"
                  :key="customButton.name + (customButton.key !== undefined ? customButton.key : '')"
                  v-bind="customButtonProps(customButton)"
                  class="btn__custom"
                  @click="onClickCustomButton(customButton)"
                >
                  {{ customButton.text }}
                </m4-button>
                <m4-button
                  v-if="tr.children && tr.children.length > 0"
                  tag="a"
                  size="sm"
                  class="btn__expand"
                  circle
                  @click="openDetail(tr.id)"
                >
                  <m4-icon icon="angle-down" class="btn__icon"></m4-icon>
                </m4-button>
              </td>
              <td v-else-if="hasCustomButtons" class="table__body-cell">
                <m4-button
                  v-if="tr.children && tr.children.length > 0"
                  tag="a"
                  size="sm"
                  class="btn__expand"
                  circle
                  @click="openDetail(tr.id)"
                >
                  <m4-icon icon="angle-down" class="btn__icon"></m4-icon>
                </m4-button>
              </td>
            </tr>
            <template v-if="tr.children && tr.children.length > 0 && isOpened(tr.id)">
              <tr v-for="(kidTr, i) in tr.children" :key="i" :class="subTrClasses(tr.children, i)">
                <td class="table__body-cell table__body-cell--children" :colspan="colspan">
                  <h3 v-if="kidTr.title" class="table__body-cell__kid-title">
                    <m4-icon icon="list"></m4-icon>
                    {{ kidTr.title }}
                  </h3>
                  <m4-select-action
                    v-if="kidTr.bulkActions && kidTr.bulkActions.length > 0"
                    :actions="kidTr.bulkActions"
                    :checked-rows="getChildCheckedRows(tr)"
                  ></m4-select-action>
                  <table class="table__body-cell__table table--striped">
                    <thead v-if="kidTr.thead">
                      <tr>
                        <th v-if="kidTr.bulkActions && kidTr.bulkActions.length > 0"></th>
                        <th
                          class="table__body-cell__table__head"
                          v-for="(th, index) in kidTr.thead"
                          :key="index"
                          :data-name="th.name"
                        >
                          {{ th.title }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(ktr, k) in kidTr.tbody" :key="k">
                        <tr :data-id="ktr.id">
                          <td v-if="kidTr.bulkActions && kidTr.bulkActions.length > 0">
                            <m4-form-field
                              type="checkbox"
                              :name="'child-checked-rows' + ktr.id + '[]'"
                              @change="(checkbox) => childSelect(tr, checkbox)"
                              :native-value="ktr.id"
                              :true-value="ktr.id"
                              autocomplete="off"
                              class="table__body-cell__table__body-cell__checkout"
                            ></m4-form-field>
                          </td>
                          <td
                            v-for="(td, j) in ktr.cells"
                            :key="j"
                            class="table__body-cell__table__body-cell"
                            :data-name="td.name"
                          >
                            <span v-html="td.value"></span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="colspan" class="text-muted padding-t-xl padding-b-xl padding-l-lg">{{ noRecordsMessage }}</td>
          </tr>
        </tbody>
      </table>
      <m4-loader v-if="loaderReordering" :width="8" text="reordering" font-size="1"></m4-loader>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4Table",
  data() {
    return {
      checkedAll: false,
      checkedRows: [],
      childCheckedRows: {},
      open: [],
      currBulkAction: null,
      draggedTr: null,
      dragOverTr: null,
      droppedTr: null,
      loaderReordering: false,
      newTBody: this.tbody,
      jsSortCol: null,
      jsSortDir: null
    };
  },
  props: {
    thead: Array,
    tbody: Array,
    settings: Boolean,
    striped: Boolean,
    jsSort: Boolean,
    hasCustomButtons: Boolean,
    bulkActions: {
      type: Array,
      default() {
        return [];
      }
    },
    noActions: Boolean,
    dragDropReorder: Boolean,
    dragDropReorderUrl: String,
    noRecordsMessage: String
  },
  computed: {
    tableClasses() {
      let classes = ["table"];
      if (this.striped) {
        classes.push("table--striped");
      }
      return classes;
    },
    colspan() {
      return (
        this.thead.length + (!this.noActions ? 1 : 0) + (this.bulkActions ? 1 : 0) + (this.hasCustomButtons ? 1 : 0)
      );
    },
    hasTopRightTools() {
      return !!this.$slots.top_right;
    }
  },
  mounted() {
    this.$nextTick(function () {
      if (this.jsSort) {
        const sort = this.getJsSortToSessionStorage();
        if (sort && sort.col && sort.dir) {
          this.jsSortCol = sort.col;
          this.jsSortDir = sort.dir;
          this.jsExecSorting();
        }
      }
    });
  },
  methods: {
    onChangeBulkAction(e) {
      this.currBulkAction = e.target.value;
    },
    onSubmitBulkAction() {
      if (this.currBulkAction) {
        this.$refs.bulkActionForm.submit();
      }
    },
    currTabId() {
      let currTabId = sessionStorage.getItem("tab_" + location.pathname);
      return currTabId ? currTabId : "main";
    },
    saveJsSortToSessionStorage() {
      sessionStorage.setItem("table-js-sort-col_" + this.currTabId() + "_" + location.pathname, this.jsSortCol);
      sessionStorage.setItem("table-js-sort-dir_" + this.currTabId() + "_" + location.pathname, this.jsSortDir);
    },
    getJsSortToSessionStorage() {
      return {
        col: sessionStorage.getItem("table-js-sort-col_" + this.currTabId() + "_" + location.pathname),
        dir: sessionStorage.getItem("table-js-sort-dir_" + this.currTabId() + "_" + location.pathname)
      };
    },
    jsSortBy(th) {
      if (th.name === this.jsSortCol) {
        this.jsSortDir = this.jsSortDir === "asc" ? "desc" : "asc";
      } else {
        this.jsSortCol = th.name;
        this.jsSortDir = "asc";
      }

      this.saveJsSortToSessionStorage();
      this.jsExecSorting();
    },
    jsExecSorting() {
      this.newTBody.sort((a, b) => {
        const cellColumnIndex = a.cells.findIndex((obj) => obj.name === this.jsSortCol);
        if (cellColumnIndex < 0 || a.cells[cellColumnIndex] === undefined || b.cells[cellColumnIndex] === undefined) {
          return 0;
        }

        let aSortValue = a.cells[cellColumnIndex].value;
        let bSortValue = b.cells[cellColumnIndex].value;
        aSortValue = aSortValue.replace(/<[^>]*>/g, "");
        bSortValue = bSortValue.replace(/<[^>]*>/g, "");

        if (aSortValue < bSortValue) {
          return this.jsSortDir === "asc" ? -1 : 1;
        }
        if (aSortValue > bSortValue) {
          return this.jsSortDir === "asc" ? 1 : -1;
        }

        return 0;
      });
    },
    trListeners(tr) {
      if (this.dragDropReorder) {
        let self = this;
        const cancelDefault = (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        };

        return {
          dragstart() {
            self.draggedTr = tr;
          },
          dragend() {
            self.draggedTr = null;
            self.dragOverTr = null;
          },
          dragenter() {
            self.dragOverTr = tr;
          },
          dragover(e) {
            cancelDefault(e);
          },
          drop() {
            self.droppedTr = tr;
            self.loaderReordering = true;

            let newTBody = [];
            for (let i = 0; i < self.newTBody.length; i++) {
              let item = self.newTBody[i];
              if (item.id + "" === self.draggedTr.id + "") {
                //remove self.draggedTr
              } else if (item.id + "" === self.droppedTr.id + "") {
                newTBody.push(Object.assign({}, self.draggedTr));
                newTBody.push(item);
              } else {
                newTBody.push(item);
              }
            }

            self.newTBody = newTBody;

            window
              .axios({
                method: "post",
                url: self.dragDropReorderUrl,
                data: {
                  draggedId: self.draggedTr.id,
                  droppedId: self.droppedTr.id
                }
              })
              .then((response) => {
                self.loaderReordering = false;
                if (response.data !== undefined) {
                  response.data.map((dataItem) => {
                    self.newTBody = self.newTBody.map((tr) => {
                      if (tr.id + "" === dataItem.id + "") {
                        tr.cells = tr.cells.map((cell) => {
                          if (cell.name === dataItem.cellName) {
                            return Object.assign({}, cell, {
                              value: dataItem.cellValue
                            });
                          } else {
                            return cell;
                          }
                        });
                      }

                      return tr;
                    });
                  });
                }
                self.draggedTr = null;
                self.dragOverTr = null;
                self.droppedTr = null;
              })
              .catch((Error) => {
                self.loaderReordering = false;
                alert(Error);
              });
          }
        };
      }
      return {};
    },
    trAttr() {
      if (this.dragDropReorder) {
        return {
          draggable: true
        };
      }
      return {};
    },
    trClasses(tr, index) {
      let classes = ["table__tr"];
      if (index % 2 === 0) {
        classes.push("table__tr--odd");
      }
      if (this.isOpened(tr.id)) {
        classes.push("table__tr--opened");
      }
      if (this.dragDropReorder) {
        classes.push("table__tr--draggable");
      }
      if (this.draggedTr && this.draggedTr.id === tr.id) {
        classes.push("table__tr--dragged");
      }
      if (this.dragOverTr && this.dragOverTr.id === tr.id) {
        classes.push("table__tr--drag-over");
      }
      return classes;
    },
    tdClasses(tr, td, index) {
      let classes = ["table__body-cell"];
      if (tr.children && tr.cells.length == index + 1 && (!tr.customButtons || tr.customButtons.length === 0)) {
        classes.push(" table__body-cell--pr");
      }
      return classes;
    },
    subTrClasses(children, index) {
      let classes = ["table__tr", "table__tr--children"];
      if (children && children.length == index + 1) {
        classes.push("table__tr--children--last");
      }
      return classes;
    },
    thSortClasses(th) {
      let classes = [];
      if (th.activeSort) {
        classes.push("sort-" + th.activeSort);
      } else if (this.jsSort && this.jsSortCol === th.name) {
        classes.push("sort-" + this.jsSortDir);
      }
      return classes;
    },
    select(checkbox) {
      if (!checkbox.checked || this.checkedRows.length != this.newTBody.length) {
        this.checkedAll = false;
      } else {
        this.checkedAll = true;
      }
    },
    selectAll() {
      this.checkedRows = [];

      this.checkedAll = !this.checkedAll;

      if (this.checkedAll) {
        for (let i in this.newTBody) {
          this.checkedRows.push(this.newTBody[i].id);
        }
      }
    },
    childKey(tr) {
      let key = tr.id + "";
      return key ? key.replace("-", "") : null;
    },
    childSelect(tr, checkbox) {
      let key = this.childKey(tr);
      if (key) {
        if (this.childCheckedRows[key] === undefined) {
          this.childCheckedRows[key] = [];
        }
        if (checkbox.checked) {
          this.childCheckedRows[key].push(checkbox.value);
        } else {
          let index = this.childCheckedRows[key].indexOf(checkbox.value);
          this.childCheckedRows[key].splice(index, 1);
        }

        this.$forceUpdate();
      }
    },
    getChildCheckedRows(tr) {
      let key = this.childKey(tr);
      if (key) {
        return this.childCheckedRows[key];
      }
      return [];
    },
    openDetail(id) {
      let index = this.open.indexOf(id);
      if (index > -1) {
        this.open.splice(index, 1);
      } else {
        this.open.push(id);
      }
    },
    isOpened(id) {
      return this.open.indexOf(id) > -1;
    },
    onClickCustomButton(customButton) {
      if (customButton.emit !== undefined) {
        this.$emit(customButton.emit.name, customButton.emit.value);
        return false;
      }
      return true;
    },
    customButtonProps(customButton) {
      let props = Object.assign({}, { ...customButton });
      delete props["text"];

      return props;
    }
  },
  watch: {
    tbody(val) {
      this.newTBody = val;
    }
  }
};
</script>
